module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ../~/moment/moment.js-exposed
// module id = 41
// module chunks = 3